import { BadgeProps } from '@twilio-paste/core/badge';

import { AppStatus } from '../../../modules/Apps';
import { TableStatus } from '../../common/TableStatus';

interface AppsTableStatusProps {
  status: AppStatus;
}

const variantByStatus: Record<AppStatus, BadgeProps['variant']> = {
  DELETED: 'error',
  DISABLED: 'warning',
  ENABLED: 'success',
};

export function AppsTableStatus({ status }: AppsTableStatusProps) {
  return <TableStatus status={status} variant={variantByStatus[status]} />;
}
